export const examAdminPapersDetail = {
  pageTitle: "试卷详情",
  notFound: "未找到对应试卷。",
  subtitlePaperCode: "试卷编号 {code}",
  subtitleVersionedCode: "试卷版本编号",
  subtitleActiveExamRefs: "正在被 {count} 场进行中/已发布考试引用",
  sections: {
    basicInfo: "基础信息",
    description: "试卷说明",
    ruleConfigs: "Rule Configurations",
    examReferences: "考试引用",
    versionHistory: "试卷版本历史",
    versionAlerts: "题目版本更新提醒",
    itemList: "题目清单",
  },
  objects: {
    basicInfo: "Basic Info",
    paperStructure: "Paper Structure",
    ruleConfigs: "Rule Configurations",
  },
  actions: {
    publish: "发布",
    archive: "归档",
    viewExam: "查看考试",
    viewSnapshot: "查看快照",
    compareCurrent: "对比当前版本",
    compareRules: "Compare Rules",
    syncAll: "全部同步到最新（更新结构并生成新版本）",
    syncSelected: "仅同步勾选项（更新结构并生成新版本）",
    selectAllUpdatable: "全选可更新题目",
    reopenWorkspace: "重新打开工作台",
    handleLater: "稍后处理",
    finishWorkspace: "已完成，生成新版本",
  },
  labels: {
    latest: "已最新",
    updatable: "可更新",
    current: "当前",
    currentVersion: "当前版本",
    historyVersion: "历史版本",
    noSnapshotData: "暂无版本快照数据",
    noRuleConfigs: "No question-type rules are configured.",
    withNewVersion: "{action} (Creates a New Version)",
  },
  fields: {
    currentVersionLabel: "当前版本",
    latestVersionLabel: "最新版本",
    scoreLabel: "分值 {score}",
    examTime: "考试时间",
    startTime: "开始：{value}",
    endTime: "结束：{value}",
    referenceVersion: "引用版本",
    referenceTime: "引用时间",
    latestVersionCreatedAt: "最新版本创建时间",
    createdBy: "创建人",
    updatedBy: "最后编辑人",
    updatedAt: "修改时间",
    ruleCount: "Count {count}",
    ruleScorePerQuestion: "{score} points each",
    knowledgePoints: "Knowledge Points:",
    tags: "Tags:",
  },
  versionDiff: {
    added: "新增题目",
    removed: "移除题目",
    replaced: "题目替换",
    versionChanged: "题目版本变化",
    scoreChanged: "分值变化",
    versionAndScoreChanged: "版本 + 分值变化",
    compareTitle: "版本差异对比 {from} -> {to}",
    compareFallbackTitle: "版本差异对比 {from} -> 当前版本",
    summaryAdded: "新增 {count}",
    summaryRemoved: "移除 {count}",
    summaryReplaced: "替换 {count}",
    summaryVersionChanged: "题目版本变化 {count}",
    summaryScoreChanged: "分值变化 {count}",
    summaryRuleAdded: "Added rule configs {count}",
    summaryRuleRemoved: "Removed rule configs {count}",
    summaryRuleUpdated: "Updated rule configs {count}",
    ruleQuestionType: "Question Type",
    ruleChangeType: "Change Type",
    ruleHistoryConfig: "Historical Rule",
    ruleCurrentConfig: "Current Rule",
    ruleAdded: "Added",
    ruleRemoved: "Removed",
    ruleUpdated: "Updated",
  },
  drawers: {
    editStructureTitle: "修改试卷结构（基于当前版本）",
    editStructureHint:
      "将基于当前版本自动带入题目与分值，你可以直接调整题目、分值和顺序；保存后生成新版本。",
    editStructureSubmit: "保存结构并生成新版本",
    editRulesTitle: "Edit Rule Configurations (Based on Current Version)",
    editRulesHint:
      "The current version's rule configurations are prefilled. You can adjust question-type rules directly. Saving creates a new version.",
    editBasicInfoTitle: "编辑试卷基本信息（不创建新版本）",
    snapshotTitle: "版本快照 {code}",
    snapshotFallbackTitle: "版本快照 {version}",
    snapshotRulesTitle: "Rule Snapshot",
  },
  structureWorkspace: {
    title: "已打开结构编辑工作台",
    hint: "请在新标签页完成题目与分值调整，完成后回到本页点击“已完成，生成新版本”。",
  },
  alerts: {
    archivedTitle: "当前试卷已归档",
    archivedDescription: "归档试卷默认只读展示；如需继续编辑，请先复制结构生成新版本试卷。",
    activeExamRefsTitle: "当前有 {count} 场进行中/已发布考试正在引用该试卷",
    activeExamRefsDescription: "继续修改试卷结构会生成新版本，不会影响这些考试已绑定的历史版本。",
    versionSyncUnavailable: "当前试卷版本不可直接同步题目版本。",
    versionSyncAvailable: "当前试卷版本有 {count} 道题可以升级到最新题目版本。",
    versionSyncDone: "当前试卷中所有题目都已是最新版本。",
    versionSyncRule: "同步会自动生成新的试卷版本，不覆盖历史版本。",
    versionSyncBlockedReason: "原因：{reason}",
  },
  stats: {
    totalExamCount: "总引用考试数：{count}",
    activeExamCount: "进行中/已发布：{count}",
    endedExamCount: "已结束/已归档：{count}",
    latestBoundAt: "最近引用时间：{value}",
    perQuestionScore: "每题 {score} 分",
    mixedScores: "分值 {scores} 分",
    totalScoreText: "共 {totalScore} 分",
    typeSummaryDescription: "{type} 共 {count} 题，{perQuestionText}，共 {totalScore} 分",
    typeSummaryCompact: "{count} 题 · {description}",
  },
  form: {
    titleLabel: "试卷名称",
    titleRequired: "请输入试卷名称",
    durationLabel: "建议时长（分钟）",
    durationPlaceholder: "可为空",
  },
  messages: {
    versionCreateSuccess: "试卷版本创建成功",
    versionSyncSuccess: "已生成试卷新版本 v{version}，更新题目 {count} 项",
    basicInfoUpdated: "试卷基本信息已更新",
    published: "试卷已发布",
    archived: "试卷已归档",
    questionCatalogNotReady: "The question catalog is not ready yet. Try again later.",
    versionAlertsNotReady: "Paper version alerts are not ready yet. Try again later.",
    popupBlockedInModal: "浏览器拦截了新标签页，请在弹窗中点击“重新打开工作台”。",
    selectItemsToSync: "请先勾选要更新的题目",
    compareCurrentVersion: "当前版本无需与自身对比",
    popupStillBlocked: "浏览器仍拦截了新标签页，请允许弹窗后重试。",
    missingWorkspaceDraftToken: "缺少工作台草稿标识，无法生成新版本",
    workspaceDraftMissing: "未找到工作台草稿，请先在新窗口完成并保存",
    workspaceDraftInvalid: "工作台草稿格式无效，无法生成新版本",
    workspaceDraftEmpty: "至少选择 1 道题后才能生成新版本",
    workspaceDraftNotFound: "未找到工作台草稿，无法生成新版本",
  },
} as const;
